
/**
 * Development mode control utility
 * Ensures the application only uses real API data, not mock data
 */

export const isDevelopmentModeDisabled = () => {
  // Always return true to ensure no mock data is used
  return true;
};

export const disableDevelopmentMode = () => {
  console.log('Development mode explicitly disabled - using only real API data');
  // Set flag to ensure no mock data usage
  localStorage.setItem('developmentModeDisabled', 'true');
};

export const enableDevelopmentMode = () => {
  console.log('Development mode cannot be enabled - real API data only');
  // Prevent enabling development mode to avoid mock data
  localStorage.setItem('developmentModeDisabled', 'true');
};

// Automatically disable development mode on import
disableDevelopmentMode();
